<template>
  <el-container>
    <el-aside width="300px"></el-aside>
    <el-main>
      <el-card class="box">
      <template v-slot:header>
        <div class="card-header">
            <span style="font-weight: bold;color: #F1F7E7;font-size: 20px;">
              <i class="el-icon-tickets" style="font-weight: bold;font-size: 20px;margin-right: 5px;"></i>Convert Motif</span>
        </div>
      </template>
      <div>
        <el-col :span="12">
          <el-row>
            <el-form>
              <el-form-item label="txt" style="font-weight: bold;">
                <el-input v-model="txtFileName" placeholder="Please select txt file" readonly></el-input>
                <div class="button-container">
                  <el-upload
                    class="upload-btn"
                    action="http://183.175.59.4/devenhancer/motif_convert/"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="medium" slot:trigger type="primary" style="margin-right: 5px;background-color: #2C3E50; border-color: #2C3E50;">select file</el-button>
                  </el-upload>
                  <el-button size="medium" type="primary" @click="submitForm" :loading="loading" style="margin-right: 5px;background-color: #2C3E50; border-color: #2C3E50;">convert</el-button>
                  <a href="@/../static/download/PreME_knownResults.txt" download="">
                    <el-button size="medium" type="primary" style="background-color: #2C3E50; border-color: #2C3E50;">example</el-button>
                  </a>
                </div>
              </el-form-item>
            </el-form>
          </el-row>
        </el-col>
        <el-col :span="12" class="col2">
          <h3 style="color:red">Function:</h3>
          <p style="font-size: large;">This module converts the transcription factor <span style="color:red">sequences</span> from Homer's results into more accurate sequences based on IUPAC codes.</p>
          <h3 style="color:red">Usage:</h3>
          <p style="font-size:  large;"> First, click select file to choose <span style="color:red">knownResults.txt</span> from Homer's processing results to upload, then click convert to wait for the results.
            You can click on "example" to show example files.</p>
        </el-col>
      </div>
    </el-card>
    </el-main>
    <el-aside width="300px"></el-aside>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      txtData: null,
      txtFileName: '',
      dlProgress: 0,
      loading: false, // 添加 loading 状态
    };
  },
  methods: {
    beforeUpload(file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType !== 'txt') {
        this.$message.error('Only .txt files can be uploaded.');
        return false;
      }
      this.txtFileName = file.name;
      this.txtData = file;
      return false;
    },
    handleUploadSuccess(response) {
      console.log(response);
    },
    async submitForm() {
      this.loading = true;
      const formData = new FormData();
      formData.append('motif_file', this.txtData); // 将键改为'motif_file'

      this.$axios.post('http://183.175.59.4/devenhancer/motif_convert/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(async response => {
          this.$router.push({ name: 'Motiflist', params: { res: response.data } });
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.box {
  margin-top: 60px;
}
.card-header {
  background-color: #2C3E50;
}
.box /deep/ .el-card__header {
  background-color: #2C3E50;
}
.col2 {
  padding: 10px;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center; /* 垂直居中对齐 */
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/analysis/Convertmotif.vue